module.exports = __webpack_public_path__ + "img/buzz_buzzingarden.8aab44c.png";